export default __webpack_public_path__ + "engine/assets/YVKKLjP.png";